module.exports = __webpack_public_path__ + "static/media/overlay0.b92e2743.png";